//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { DepartmentGroupModel, DepartmentModel } from '@app/catalog';

@Component({
  selector: 'assign-department-to-department-groups',
  standalone: false,
  templateUrl: './assign-department-to-department-groups.component.html',
  styleUrl: './assign-department-to-department-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignDepartmentToDepartmentGroupsComponent {
  onCancelAssignment = output();

  departmentGroups = input.required<DepartmentGroupModel[]>();
  assignedDepartments = input.required<DepartmentModel[]>();
  departments = input.required<DepartmentModel[]>();



  public applyAssignment() {

  }
}
